import React from 'react';
import PropTypes from 'prop-types';

import CaregiverDescriptionEdit from './CaregiverDescriptionEdit';
import CaregiverDescriptionView from './CaregiverDescriptionView';

const DescriptionBox = (props) => {
  const [isEditing, setIsEditing] = React.useState(false);

  const {
    caregiverData,
    caregiverBackend,
  } = props;

  if (isEditing) {
    return (
      <CaregiverDescriptionEdit
        caregiverData={caregiverData}
        caregiverBackend={caregiverBackend}
        setIsEditing={setIsEditing}
      />
    );
  } else {
    return (
      <CaregiverDescriptionView
        caregiverData={caregiverData}
        setIsEditing={setIsEditing}
      />
    );
  }
};
DescriptionBox.propTypes = {
  caregiverData: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
};

export default React.memo(DescriptionBox);
